import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import ModalConfirm from '../modal/modal_confirm';
import ModalAlert from '../modal/modal_alert';
import ModalContentBase from '../modal/modal_content_base';
import WallCommentReply from './wall_comment_reply';
import WallsCommentsLikeUsers from './walls_comments_like_users';
import axios from '../../../axios';
import Loader from "../loader";

export default createReactClass({
  displayName: 'Root',
  propTypes: {
    wallId: PropTypes.number,
    eventId: PropTypes.number,
    currentUser: PropTypes.object,
    isCommentShow: PropTypes.bool,
    isFormShow: PropTypes.bool,
    isManager: PropTypes.bool,
  },
  getInitialState() {
    return {
      isCommentShow: this.props.isCommentShow ? true : false,
      comment: '',
      comments: [],
      isUploading: false,
      isDisplay: true,
      deleteCommentId: 0,
      commentIdForLikeUsers: 0,
      modalLikeUsersRef: React.createRef(),
      modalRegistrationAfterPostRef: React.createRef(),
      commentIdForViolation: 0,
      loading: true,
    };
  },
  handleComment(e) {
    this.setState({
      comment: e.target.value,
    });
  },
  handleCommentSubmitBtn() {
    this.setState({
      isUploading: true,
    });

    const formData = new FormData();
    formData.append('comment', this.state.comment);
    formData.append('wall_id', this.props.wallId);

    $.ajax({
      url: '/api/walls/walls_comment_write',
      type: 'POST',
      cache: false,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(
        function () {
          this.setState({
            comment: '',
            isUploading: false,
          });
          this.loadCommentsFromServer();
          this.scroll();

          const isAnonymous =
            this.props.currentUser && this.props.currentUser['anonymous?'];
          if (isAnonymous) {
            this.state.modalRegistrationAfterPostRef.current.openModal();
          }
        }.bind(this)
      )
      .fail(function () { }.bind(this));
  },
  handleLikeButton(e) {
    e.preventDefault();

    const commentId = e.currentTarget.dataset.comment_id;
    const formData = new FormData();
    formData.append('walls_comment_id', commentId);
    $.ajax({
      url: '/api/walls/like_comment',
      type: 'POST',
      cache: false,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(
        function () {
          this.loadCommentsFromServer();
        }.bind(this)
      )
      .fail(function () { }.bind(this));
  },
  handleShowLikeUsersButton(e) {
    e.preventDefault();
    this.setState({
      commentIdForLikeUsers: e.currentTarget.dataset.comment_id,
    });
    this.state.modalLikeUsersRef.current.openModal();
  },
  handleDeleteCommentBtn(e) {
    e.preventDefault();
    this.setState({
      deleteCommentId: e.currentTarget.dataset.comment_id,
    });
    this.deleteCommentConfirm.openModal();
  },
  handleReportCommentBtn(e) {
    e.preventDefault();
    const commentId = e.currentTarget.dataset.comment_id;
    this.setState({
      commentIdForViolation: commentId,
    });
    this.reportCommentConfirm.openModal();
  },
  deleteComment() {
    const formData = new FormData();
    formData.append('walls_comment_id', this.state.deleteCommentId);
    $.ajax({
      url: '/api/walls/delete_comment',
      type: 'POST',
      cache: false,
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(
        function () {
          this.loadCommentsFromServer();
        }.bind(this)
      )
      .fail(function () { }.bind(this));
  },
  reportComment() {
    const body = JSON.stringify({
      walls_comment_id: this.state.commentIdForViolation,
    });
    axios.post('/api/walls_comments_violations', body).then(() => {
      this.reportCommentComplete.openModal();
    });
  },
  loadCommentsFromServer() {
    this.setState({ loading: true });
    $.ajax({
      url: '/api/walls/walls_comments',
      type: 'GET',
      cache: false,
      data: {
        wall_id: this.props.wallId,
      },
      contentType: false,
    })
      .done(
        function (data) {
          this.setState({
            comments: data.wallsComments,
            loading: false,
          });
        }.bind(this)
      )
      .fail(function () {
        this.setState({ loading: false });
      }.bind(this));
  },
  scroll() {
    var target = $('#comment-area');
    $('html, body').scrollTop(target.height());
  },
  componentDidMount() {
    if (this.props.isCommentShow) this.loadCommentsFromServer();
    this.scroll();
  },
  render() {
    const NoContents = () => {
      return (
        <div
          className="bg-graydark rounded p-2 d-flex align-items-center justify-content-center mt-1 mb-3 mx-auto"
          style={{ maxWidth: '312px' }}
        >
          <span className="text-black-50 text-fz-11px">削除された投稿</span>
        </div>
      );
    };

    const currentUser = this.props.currentUser ? this.props.currentUser : null;
    const eventId = this.props.eventId;
    const isFormShow = this.props.isFormShow;
    const isManager = this.props.isManager;
    const handleDeleteCommentBtn = this.handleDeleteCommentBtn;
    const handleReportCommentBtn = this.handleReportCommentBtn;
    const handleLikeButton = this.handleLikeButton;
    const handleShowLikeUsersButton = this.handleShowLikeUsersButton;
    const commentList = this.state.isCommentShow
      ? this.state.comments.map(function (comment) {
        if (!comment.user) return;
        const like_user_ids = comment.walls_comments_like_users.map(function (
          like_user
        ) {
          return like_user.user_id;
        });
        return (
          <li key={comment.id}>
            {comment.is_deleted || !comment.user ? (
              <NoContents />
            ) : (
              <div className="row justify-content-around align-items-start pb-3">
                <div className="col-1 col-md-1 pl-0 mt-1">
                  <img
                    src={comment.company
                      ? (comment.companies_user ? comment.companies_user.avatar_thumb : '' ) 
                      : (comment.user ? comment.user.avatar_thumb : '')}
                    className="event-member-icon"
                  />
                </div>
                <div className="col">
                  <div className="d-flex justify-content-between pl-1 mb-1" style={{ width: '94%' }}>
                    <p className="text-fz-11px text-fw-bold text-fz-green mb-0">
                      {comment.company ? (
                        <a
                          href={"/community/" + comment.company.id_to_param + "/member/" + comment.companies_user.member_id}
                          style={{ textDecoration: "none" }}
                        >
                          @{comment.companies_user
                            ? comment.company.is_real_name_required 
                              ? comment.companies_user.view_full_name_disp : 
                                comment.companies_user.nickname
                            : "退会ユーザー"}
                        </a>
                        ) : (
                        <a
                          href={"/member/profile/" + comment.user.tunagate_id}
                          style={{ textDecoration: "none" }}
                        >
                          @{comment.user
                            ? comment.user.tunagate_id
                            : "退会ユーザー"}
                        </a>
                        )
                      }
                    </p>
                    <div className="d-flex">
                      <p className="text-fz-xs text-black-20 mb-0">
                          {comment.created_at_time_ago_format}
                      </p>
                      <div className="dropdown dropleft">
                        <img
                          style={{ padding: '0 2px 0 12px' }}
                          id="dropdownMenu"
                          height={15}
                          className="position-absolute"
                          data-toggle="dropdown"
                          src="/assets2019/img/icon_reader.svg"
                          alt=""
                        />
                        <div className="dropdown-menu" aria-labelledby="dropdownMenu">
                          {currentUser && currentUser.id == comment.user_id ? (
                            <button
                              onClick={handleDeleteCommentBtn}
                              data-comment_id={comment.id}
                              className="dropdown-item btn btn-light text-danger text-center"
                              type="button"
                            >
                              削除する
                            </button>
                          ) : (
                            <button
                              onClick={handleReportCommentBtn}
                              data-comment_id={comment.id}
                              className="dropdown-item btn btn-light text-primary text-center"
                              type="button"
                            >
                              通報する
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <p
                    className="text-fz-11px card border-0 bg-white mb-0 ml-2 p-3"
                    dangerouslySetInnerHTML={{
                      __html: comment.comment_display,
                    }}
                  />
                  {/* <div className="d-flex">
                    {!currentUser ? (
                      ''
                    ) : !like_user_ids.includes(currentUser.id) ? (
                      <a
                        href=""
                        onClick={handleLikeButton}
                        data-comment_id={comment.id}
                        className="text-black-20 ml-2"
                      >
                        ♡
                      </a>
                    ) : (
                      <p className="text-fz-xs text-black-20 mt-1 mb-0 ml-2">
                        いいね済
                      </p>
                    )}
                    {like_user_ids.length > 0 ? (
                      <a
                        href=""
                        onClick={handleShowLikeUsersButton}
                        data-comment_id={comment.id}
                        className="text-fz-xs text-black-20 mt-1 mb-0 ml-2"
                      >
                        {like_user_ids.length}件のいいね
                      </a>
                    ) : (
                      ''
                    )}
                  </div> */}
                  <WallCommentReply
                    wallId={comment.wall_id}
                    wallsCommentId={comment.id}
                    currentUser={currentUser}
                    isFormShow={isFormShow}
                  />
                </div>
              </div>
            )}
          </li>
        );
      })
      : '';

    const commentForm =
      isFormShow && currentUser && !currentUser.is_banned ? (
        <div className="fixed-bottom bg-graydark">
          <div className="container col-md-8 col-lg-6 pr-0">
            <div className="input-group pt-2 pb-2">
              <textarea
                className="form-control border-0 rounded h-1em bg-light-gray text-fz-16px"
                style={{ height: 58 }}
                type="text"
                rows="1"
                placeholder={isManager ? 'クリエイターは質問・コメントできません。' : "質問・コメントする..."}
                onChange={this.handleComment}
                value={this.state.comment}
              />
              <div className="input-group-append">
                <button
                  className="btn text-black-50 text-fw-bold pt-1"
                  onClick={this.handleCommentSubmitBtn}
                  disabled={isManager}
                >
                  送信
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="fixed-bottom bg-graydark">
          <div className="container col-md-8 col-lg-6 pr-0">
            <div className="pt-2 pb-2 text-center">
              <p className="text-fz-11px">
                質問・コメントするには
                <a href={`/users/sign_in?rurl=/event/${eventId}/comments`}>
                  ログイン
                </a>
                が必要です
              </p>
            </div>
          </div>
        </div>
      );
    let commentArea = this.state.isCommentShow ? (
      <div>
        <div className="pt-3 pb-3">
          {this.state.comments.length > 0 ? (
            <ul className="list-unstyled mb-2">{commentList}</ul>
          ) : (
            <div
              className="pt-5"
              style={{ filter: 'grayscale(100%)', textAlign: 'center' }}
            >
              <img
                src="/favicon.ico"
                height="60px"
                style={{ borderRadius: '50px' }}
              />
              <h6 className="text-gray text-fz-14px text-fw-bold pt-5 text-center">
                イベントの主催者に質問することができます
              </h6>
              <p className="text-gray text-fz-11px text-center">
                イベント参加にあたり不明なこと、不安なことを
                <br />
                主催者に質問しましょう。
              </p>
            </div>
          )}
          {commentForm}
        </div>
      </div>
    ) : (
      ''
    );

    const likeUsersModalContent = (
      <WallsCommentsLikeUsers
        wallsCommentId={this.state.commentIdForLikeUsers}
      />
    );

    const registrationAfterPostModalContent = (
      <React.Fragment>
        <div className="modal-view-header">
          <p style={{ margin: '0px 0px 6px', paddingTop: '1.5em' }}>
            <strong>会員登録をしよう！</strong>
          </p>
          <div
            className="modal-view-close"
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              padding: '0.5em 1.0em',
            }}
            onClick={() =>
              this.state.modalRegistrationAfterPostRef.current.closeModal()
            }
          >
            <span className="text-gray">&times;</span>
          </div>
        </div>
        <div className="modal-view-body" style={{ padding: '1.5em 2em' }}>
          <p className="text-fz-13px">
            会員登録すると、あなたの質問・コメントにクリエイターからの返事を受け取れます。
          </p>
          <div
            className="align-self-center"
            style={{ minWidth: '225px', paddingTop: '1.5em' }}
          >
            <a
              href={`/users/sign_up?rurl=${encodeURIComponent(
                location.href
              )}#anonymous`}
              className="a-button a-button__top a-button--orange w-100 text-white mx-auto mb-2"
            >
              会員登録ページへ
            </a>
          </div>
        </div>
      </React.Fragment>
    );

    return this.state.isDisplay ? (
      <div
        className="bg-gray pl-2 min-h-100vh"
        style={{ paddingBottom: '50px' }}
      >
        {this.state.loading ? (
          <Loader isActive={this.state.loading} />
        ) : (
          <div
            id="comment-area"
            className="container col-md-8 col-lg-6 pt-3 min-h-100vh"
          >
            {commentArea}
          </div>
        )}
        <ModalConfirm
          ref={(c) => {
            this.deleteCommentConfirm = c;
          }}
          title="コメントの削除"
          content="コメントを削除しますか？"
          approveFunc={this.deleteComment}
        />
        <ModalConfirm
          ref={(c) => {
            this.reportCommentConfirm = c;
          }}
          title="コメントを通報"
          content="コメントを通報しますか？"
          approveFunc={this.reportComment}
        />
        <ModalAlert
          ref={(c) => {
            this.reportCommentComplete = c;
          }}
          title="完了"
          content="コメントの通報が完了しました。"
        />
        <ModalContentBase
          ref={this.state.modalLikeUsersRef}
          previewContent={<div />}
          modalContent={likeUsersModalContent}
        />
        <ModalContentBase
          ref={this.state.modalRegistrationAfterPostRef}
          previewContent={<div />}
          modalContent={registrationAfterPostModalContent}
        />
      </div>
    ) : (
      ''
    );
  },
});
